import type { RouteObject } from 'react-router';

import * as searchOrgsHorizonRouteExports from '#/modules/search/orgs/page/SearchOrgs.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import { searchOrgsRoutePaths } from './searchOrgs.route-paths';

const searchOrgsRouteObject = horizonRouteToObject(
  searchOrgsHorizonRouteExports,
);
const createSearchOrgsRouteObject = (path: string): RouteObject => ({
  path,
  ...searchOrgsRouteObject,
});

export const searchOrgsRouteObjects = searchOrgsRoutePaths.map(
  createSearchOrgsRouteObject,
) satisfies RouteObject[];
